module.exports = __webpack_public_path__ + "static/media/thumbnail.dd4d1434.jpeg";